function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Union_1",
  "data-name": "Union 1",
  d: "M3.5,8.967A25.9,25.9,0,0,1,0,6l.007-.009A26.19,26.19,0,0,1,3.5,3c1.919-1.369,4.816-3,7.722-3s5.817,1.632,7.747,3A26.173,26.173,0,0,1,22.5,6l-.007.009a26.442,26.442,0,0,1-3.521,2.956c-1.931,1.352-4.841,2.964-7.747,2.964S5.422,10.319,3.5,8.967Zm.679-5.534A23.249,23.249,0,0,0,1,6.045a23.4,23.4,0,0,0,3.182,2.58,13.4,13.4,0,0,0,7.014,2.58,13.515,13.515,0,0,0,7.036-2.58,23.539,23.539,0,0,0,3.2-2.58,23.806,23.806,0,0,0-3.2-2.613C16.478,2.241,13.835.82,11.2.82A13.307,13.307,0,0,0,4.181,3.433ZM8,6a3,3,0,1,1,3,3A3,3,0,0,1,8,6ZM9,6a2,2,0,1,0,2-2A2,2,0,0,0,9,6Z",
  fill: "#fff"
});

var SvgIcoEye = function SvgIcoEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.5,
    height: 11.93,
    viewBox: "0 0 22.5 11.93",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-eye.744600bd.svg";
export { ForwardRef as ReactComponent };